import React from 'react';
import authService from '../services/authService';
import Header from './Header';

function Login() {
  return (
    <div style={{
      minHeight: '100vh',
      backgroundImage: 'url(/forester-background.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      display: 'flex',
      flexDirection: 'column'
    }}>
      <Header />
      <div className="container" style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
        <div className="row justify-content-center w-100">
          <div className="col-md-6">
            <div className="card shadow" style={{ backgroundColor: 'rgba(255, 255, 255, 0.95)' }}>
              <div className="card-body text-center p-5">
                <img 
                  src="/subaru-logo.svg" 
                  alt="Subaru Logo" 
                  style={{ width: '120px', marginBottom: '30px' }}
                />
                <h2 className="mb-4">Welcome to the Subaru of Indiana Automotive Secure AI Gateway</h2>
                {window.CONFIG.DEV_MODE ? (
                  <>
                    <div className="alert alert-warning mb-4">
                      <strong>Development Mode</strong><br />
                      Authentication is disabled for local development
                    </div>
                    <p className="text-muted mb-4">Click below to continue without authentication</p>
                  </>
                ) : (
                  <p className="text-muted mb-4">Please sign in with your SIA credentials</p>
                )}
                <button 
                  className="btn btn-primary btn-lg"
                  onClick={() => authService.login()}
                >
                  {window.CONFIG.DEV_MODE ? 'Continue' : 'Sign In'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
